import { EProductType, IProductResponse } from 'models/product'

// Серым подсвечиваются только вариации — всегда, независимо от группировки.
// Основные товары остаются белыми.
export function groupProducts(products: IProductResponse[]): {
  sorted: IProductResponse[]
  highlightedSet: Set<string>
} {
  const highlightedSet = new Set<string>()
  for (const product of products) {
    if (product.type === EProductType.VARIATION) {
      highlightedSet.add(product._id)
    }
  }

  return { sorted: products, highlightedSet }
}
